module.exports = __webpack_public_path__ + "static/img/6-1.efddadd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/feature/face/6-1.png
// module id = uOLd
// module chunks = 1